import { UPDATE_HOME } from "../Actions/homeActions.js";

const INITIAL_STATE = {
  currentSearch: "",
};

const filterHomeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_HOME: {
      return {
        ...state,
        ...action.value,
      };
    }
    default:
      return state;
  }
};

export default filterHomeReducer;
